import {
  SET_BREADCRUMB,
  SET_KEEP_ME_LOGGED_IN,
  SET_ERROR,
  ENABLE_POWER_USER_MODE,
  SET_VIEW_UNMATCHED,
} from "../constants/actionTypes";

const common = (state = {}, action) => {
  switch (action.type) {
    case SET_BREADCRUMB:
      return {
        ...state,
        breadcrumb: {
          path: action.breadcrumb,
          picture: action.picture,
        },
      };
    case SET_KEEP_ME_LOGGED_IN:
      return {
        ...state,
        ...action.payload,
      };
    case SET_ERROR:
      return {
        ...state,
        ...action.payload,
      };
    case ENABLE_POWER_USER_MODE:
      return {
        ...state,
        powerUserModeEnabled: action.payload,
      };
    case SET_VIEW_UNMATCHED:
      return {
        ...state,
        viewUnmatched: action.payload,
      };
    default:
      return state;
  }
};

export default common;
